export default __webpack_public_path__ + "static/media/1383.37ffa0e9.png";